import PropTypes from 'prop-types';
import React from 'react';
import ResponsiveNavigation from '../ResponsiveNavigation.jsx';
import NavigationRegion from '../NavigationRegion.jsx';
import ContextDropdown from '../ContextDropdown.jsx';
import UserDropdown from '../UserDropdown.jsx';
import HelpDropdown from '../HelpDropdown.jsx';
import HelpBottomDropdown from '../HelpBottomDropdown.jsx';
import UserBottomDropdown from '../UserBottomDropdown.jsx';
import LeftNavigationLink from '../LeftNavigationLink.jsx';
import MessagesLink from '../MessagesLink.jsx';
import BottomNavigationLink from '../BottomNavigationLink.jsx';
import connectToI18n from 'modules/i18n/connectToI18n';

export class HostQuestionnaireNavigation extends React.Component {
    static propTypes = {
        isSmallWidth: PropTypes.bool,
        activeLink: PropTypes.string,
        trans: PropTypes.func.isRequired,
    };

    render() {
        const t = this.props.trans;

        const { isSmallWidth, activeLink } = this.props;

        return (
            <ResponsiveNavigation isSmallWidth={isSmallWidth}>
                <NavigationRegion position="top" legacy>
                    <div className="topNavigation-left">
                        <ContextDropdown {...this.props} />
                    </div>
                    <div className="topNavigation-right">
                        <MessagesLink {...this.props} />
                        <HelpDropdown {...this.props} />
                        <UserDropdown {...this.props} />
                    </div>
                </NavigationRegion>
                <NavigationRegion position="left">
                    <LeftNavigationLink
                        href="progress"
                        icon="progress"
                        isActive={activeLink === 'menu.progression'}
                    >
                        {t('navigation.left.progress')}
                    </LeftNavigationLink>
                    <LeftNavigationLink
                        href="questionnaire"
                        icon="questionnaire"
                        isActive={activeLink === 'menu.questionnaire'}
                    >
                        {t('navigation.left.questionnaire')}
                    </LeftNavigationLink>
                </NavigationRegion>
                <NavigationRegion position="bottom">
                    <BottomNavigationLink icon="progress" href="progress">
                        {t('navigation.bottom.progress')}
                    </BottomNavigationLink>
                    <BottomNavigationLink icon="questionnaire" href="questionnaire">
                        {t('navigation.bottom.questionnaire')}
                    </BottomNavigationLink>
                    <BottomNavigationLink />
                    <UserBottomDropdown {...this.props} />
                    <HelpBottomDropdown {...this.props} />
                </NavigationRegion>
            </ResponsiveNavigation>
        );
    }
}

export default connectToI18n(HostQuestionnaireNavigation);
